import React, { useEffect, useState, useRef } from "react";
import moment from "moment-timezone";
import { getNextPrayerOrJummah } from "../../utils/prayerUtils";

const NextIqamahCountdown = ({ prayerData, timezone }) => {
  const [countdownStr, setCountdownStr] = useState("--:--:--");
  
  // Use refs to store latest data without triggering re-renders loop
  const eventRef = useRef(null);
  const dataRef = useRef({ prayerData, timezone });

  useEffect(() => {
    dataRef.current = { prayerData, timezone };
  }, [prayerData, timezone]);

  useEffect(() => {
    const tick = () => {
      const { prayerData, timezone } = dataRef.current;
      if (!prayerData || !timezone) return;

      const now = moment.tz(moment(), timezone);

      // A. Find/Refresh the Target Event
      const currentEvent = getNextPrayerOrJummah(now, prayerData.iqamatimes, prayerData.jummahTimes, 0);
      eventRef.current = currentEvent;

      if (!currentEvent) {
        setCountdownStr("0:00:00");
        return;
      }

      // B. Calculate Remaining Time
      const diff = currentEvent.time.diff(now);

      if (diff <= 0) {
        setCountdownStr("0:00:00");
      } else {
        const duration = moment.duration(diff);
        
        // ✅ FIX: Removed .padStart(2, "0") for hours to cut the leading zero
        const h = Math.floor(duration.asHours()).toString();
        
        // Keep minutes/seconds padded for correct digital clock look (e.g. 1:05:09)
        const m = duration.minutes().toString().padStart(2, "0");
        const s = duration.seconds().toString().padStart(2, "0");
        
        setCountdownStr(`${h}:${m}:${s}`);
      }
    };

    tick(); 
    const intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="px-[5svh] mb-[1svh] text-center">
      <div className="bg-[#76A74C] text-white rounded-lg shadow-md">
        {/* Title */}
        <div className="text-[3.5svh] font-medium uppercase pt-[1svh]">
          Next Iqamah In
        </div>

        {/* Dynamic Countdown */}
        <div className="text-[5svh] font-semibold font-mono tracking-wider">
          {countdownStr}
        </div>
      </div>
    </div>
  );
};

export default NextIqamahCountdown;